import { render, staticRenderFns } from "./TextWithPeoplePanel.vue?vue&type=template&id=3eabfe27&scoped=true&"
import script from "./TextWithPeoplePanel.vue?vue&type=script&lang=ts&"
export * from "./TextWithPeoplePanel.vue?vue&type=script&lang=ts&"
import style0 from "./TextWithPeoplePanel.vue?vue&type=style&index=0&id=3eabfe27&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eabfe27",
  null
  
)

export default component.exports